(function () {
  'use strict';

  var STAR_PATH = 'M12 2.6l2.9 6.2 6.8.8-5 4.7 1.3 6.7L12 17.7 6 21l1.3-6.7-5-4.7 6.8-.8z';
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
  var VERIFIED = '<span class="bzr-verified"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>Verifiziert</span>';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STATIC_ID = 'shopify-section-belari-reviews';
  var PIN_ORDER = 'pinned_rank.asc.nullslast';
  var OBJ = '/storage/v1/object/public/';
  var RENDER = '/storage/v1/render/image/public/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Supabase image transformation: small, responsive thumbnails for the grid; the lightbox keeps the original. */
  function thumb(u, w) {
    if (u.indexOf(OBJ) === -1) return u;
    return u.replace(OBJ, RENDER) + '?width=' + w + '&quality=72&resize=contain';
  }
  function stars(n, extra) {
    var h = '';
    for (var i = 1; i <= 5; i++) h += '<span class="bzr-star' + (i <= n ? ' is-on' : '') + '">' + STAR + '</span>';
    return '<span class="bzr-stars ' + (extra || '') + '" aria-label="' + n + ' von 5 Sternen">' + h + '</span>';
  }
  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }
  function fmtDate(iso) {
    try { return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch (e) { return ''; }
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function confetti(host) {
    if (REDUCED || !host) return;
    var c = document.createElement('canvas');
    c.className = 'bzr-confetti';
    host.appendChild(c);
    var W = c.width = host.clientWidth, H = c.height = host.clientHeight;
    var ctx = c.getContext('2d');
    var colors = ['#c9a86a', '#e8d5ae', '#121212', '#f6e7c9', '#f3c6c6', '#ffffff'];
    var ps = [];
    for (var i = 0; i < 160; i++) {
      ps.push({
        x: W / 2 + (Math.random() - .5) * W * .25, y: H * .45,
        vx: (Math.random() - .5) * 16, vy: -(Math.random() * 13 + 6), g: .38,
        w: 5 + Math.random() * 6, h: 7 + Math.random() * 9,
        r: Math.random() * Math.PI, vr: (Math.random() - .5) * .35,
        c: colors[i % colors.length], a: 1
      });
    }
    var start = performance.now();
    (function frame(t) {
      var e = t - start;
      ctx.clearRect(0, 0, W, H);
      ps.forEach(function (p) {
        p.vy += p.g; p.x += p.vx; p.y += p.vy; p.vx *= .985; p.r += p.vr;
        if (e > 1500) p.a = Math.max(0, p.a - .035);
        ctx.save(); ctx.globalAlpha = p.a; ctx.translate(p.x, p.y); ctx.rotate(p.r);
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore();
      });
      if (e < 2600) requestAnimationFrame(frame); else c.remove();
    })(start);
  }

  function resizeImage(file, max, quality) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        var scale = Math.min(1, max / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * scale); c.height = Math.round(h * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { b ? resolve(b) : reject(new Error('encode')); }, 'image/jpeg', quality);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  }

  function Widget(root) {
    var d = root.dataset;
    this.root = root;
    this.url = d.supabaseUrl.replace(/\/$/, '');
    this.key = d.supabaseKey;
    this.productId = d.productId ? Number(d.productId) : null;
    this.productHandle = d.productHandle || null;
    this.source = d.source || 'auto';
    this.threshold = Number(d.threshold || 5);
    this.pageSize = Number(d.pageSize || 20);
    this.discountCode = (d.discountCode || '').trim();
    this.texts = {
      photoTitle: d.textPhotoTitle, photoSub: d.textPhotoSub, photoOffer: d.textPhotoOffer,
      textTitle: d.textTextTitle, textPlaceholder: d.textTextPlaceholder,
      thanksTitle: d.textThanksTitle, thanksLive: d.textThanksLive, thanksPending: d.textThanksPending, thanksCode: d.textThanksCode
    };
    this.items = [];
    this.offset = 0;
    this.sort = 'photos';
    this.scopeProduct = false;
    this.filterRating = null;
    this.done = false;
    this.cols = [];
    this.q = function (sel) { return root.querySelector(sel); };
    var section = root.closest('.shopify-section') || root.parentElement;
    this.detail = section.querySelector('[data-bzr-detail]') || document.querySelector('[data-bzr-detail]');
    this.funnel = section.querySelector('[data-bzr-funnel]') || document.querySelector('[data-bzr-funnel]');
    this.init();
  }

  Widget.prototype.headers = function (extra) {
    var h = { apikey: this.key, Authorization: 'Bearer ' + this.key };
    if (extra) for (var k in extra) h[k] = extra[k];
    return h;
  };

  Widget.prototype.rest = function (path, opts) {
    opts = opts || {};
    return fetch(this.url + path, {
      method: opts.method || 'GET',
      headers: this.headers(Object.assign({ 'Content-Type': 'application/json' }, opts.headers || {})),
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t || r.status); });
      return r.status === 204 || r.status === 201 ? null : r.json();
    });
  };

  Widget.prototype.stats = function (productId) {
    return this.rest('/rest/v1/rpc/product_review_stats', { method: 'POST', body: { p_product_id: productId } });
  };

  /* Central settings (e.g. the current discount code) are maintained in the Review-Admin; the section setting is only a fallback. */
  Widget.prototype.loadSettings = function () {
    var self = this;
    return this.rest('/rest/v1/rpc/review_public_settings', { method: 'POST', body: {} }).then(function (s) {
      if (s && typeof s.discount_code === 'string') self.discountCode = s.discount_code.trim();
    }).catch(function (e) { console.warn('[bzr] settings', e); });
  };

  Widget.prototype.init = function () {
    var self = this;
    this.bindUI();
    this.loadSettings();
    var p = Promise.resolve(null);
    if (this.productId && this.source !== 'all') {
      p = this.stats(this.productId).then(function (s) {
        var n = s && s.review_count ? Number(s.review_count) : 0;
        self.scopeProduct = self.source === 'product' || n >= self.threshold;
        return self.scopeProduct ? s : null;
      });
    }
    p.then(function (s) { return s || self.stats(null); })
      .then(function (s) { self.renderSummary(s); self.loadMore(); })
      .catch(function (e) { console.warn('[bzr] stats', e); self.loadMore(); });
  };

  Widget.prototype.renderSummary = function (s) {
    var avg = Number(s.average || 0);
    var count = Number(s.review_count || 0);
    this.q('[data-bzr-avg]').innerHTML = stars(Math.round(avg), 'bzr-stars--lg');
    this.q('[data-bzr-count-label]').textContent = count + ' ' + (count === 1 ? 'Bewertung' : 'Bewertungen');
    var bd = s.breakdown || {};
    var html = '';
    for (var r = 5; r >= 1; r--) {
      var c = Number(bd[String(r)] || 0);
      var pct = count ? Math.round(c / count * 100) : 0;
      html += '<button type="button" data-bd="' + r + '">' + stars(r) + '<span class="bzr-bar"><i style="width:' + pct + '%"></i></span><span>' + c + '</span></button>';
    }
    html += '<button type="button" class="bzr-bd-all" data-bd="all">Alle anzeigen</button>';
    this.q('[data-bzr-breakdown]').innerHTML = html;
  };

  Widget.prototype.query = function () {
    var params = ['select=*', 'limit=' + this.pageSize, 'offset=' + this.offset];
    if (this.scopeProduct && this.productId) params.push('product_id=eq.' + this.productId);
    if (this.filterRating) params.push('rating=eq.' + this.filterRating);
    if (this.sort === 'newest') params.push('order=' + PIN_ORDER + ',created_at.desc');
    else if (this.sort === 'highest') params.push('order=' + PIN_ORDER + ',has_photo.desc,rating.desc,created_at.desc');
    else params.push('order=' + PIN_ORDER + ',has_photo.desc,created_at.desc');
    return '/rest/v1/product_reviews_public?' + params.join('&');
  };

  Widget.prototype.loadMore = function () {
    var self = this;
    var btn = this.q('[data-bzr-more]');
    if (this.done) return;
    btn.disabled = true;
    this.rest(this.query()).then(function (rows) {
      rows = rows || [];
      self.offset += rows.length;
      if (rows.length < self.pageSize) self.done = true;
      self.ensureCols();
      rows.forEach(function (r) { self.items.push(r); self.place(self.card(r)); });
      self.q('[data-bzr-empty]').hidden = self.items.length > 0;
      btn.hidden = self.done;
      btn.disabled = false;
    }).catch(function (e) {
      console.warn('[bzr] load', e);
      btn.disabled = false;
    });
  };

  Widget.prototype.reset = function () {
    this.items = []; this.offset = 0; this.done = false;
    this.q('[data-bzr-grid]').innerHTML = '';
    this.cols = [];
    this.loadMore();
  };

  Widget.prototype.colCount = function () {
    var vw = document.documentElement.clientWidth || window.innerWidth || 1e9;
    var w = Math.min(this.root.clientWidth || 1e9, vw);
    var cs = getComputedStyle(this.root.parentElement);
    var desktop = Number(cs.getPropertyValue('--bzr-cols-desktop')) || 4;
    var tablet = Number(cs.getPropertyValue('--bzr-cols-tablet')) || Math.min(3, desktop);
    var mobile = Number(cs.getPropertyValue('--bzr-cols-mobile')) || 2;
    if (w < 600) return mobile;
    if (w < 900) return tablet;
    return desktop;
  };

  Widget.prototype.ensureCols = function () {
    var grid = this.q('[data-bzr-grid]');
    var n = this.colCount();
    if (this.cols.length === n) return;
    grid.innerHTML = '';
    this.cols = [];
    for (var i = 0; i < n; i++) { var c = el('<div class="bzr__col"></div>'); grid.appendChild(c); this.cols.push(c); }
    var self = this;
    this.items.forEach(function (r) { self.place(self.card(r)); });
  };

  Widget.prototype.place = function (node) {
    var best = this.cols[0];
    for (var i = 1; i < this.cols.length; i++) if (this.cols[i].offsetHeight < best.offsetHeight) best = this.cols[i];
    best.appendChild(node);
  };

  Widget.prototype.card = function (r) {
    var imgs = r.image_urls || [];
    var html = '<article class="bzr-card" tabindex="0" role="button">';
    if (imgs.length) {
      var u = imgs[0];
      var cols = Math.max(1, this.cols.length || this.colCount());
      var sizes = 'calc((min(100vw, ' + (parseInt(getComputedStyle(this.root).maxWidth, 10) || 1400) + 'px) - 48px) / ' + cols + ')';
      html += '<div class="bzr-card__img"><img src="' + esc(thumb(u, 540)) + '" srcset="' + esc(thumb(u, 360)) + ' 360w, ' + esc(thumb(u, 540)) + ' 540w, ' + esc(thumb(u, 800)) + ' 800w" sizes="' + sizes + '" data-orig="' + esc(u) + '" alt="Kundenfoto von ' + esc(r.display_name) + '" loading="lazy" decoding="async">';
      if (imgs.length > 1) html += '<span class="bzr-card__more"><svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 16l5-5 4 4 3-3 6 6"/></svg>+' + (imgs.length - 1) + '</span>';
      html += '</div>';
    }
    html += '<div class="bzr-card__body"><div class="bzr-card__name">' + esc(r.display_name) + (r.verified ? VERIFIED : '') + '</div>' + stars(r.rating) + '<p class="bzr-card__text">' + esc(r.body) + '</p></div></article>';
    var node = el(html);
    var img = node.querySelector('img');
    if (img) img.addEventListener('error', function () { this.removeAttribute('srcset'); this.removeAttribute('sizes'); this.src = this.dataset.orig; }, { once: true });
    if (img) {
      var loaded = function () { img.parentElement.classList.add('is-loaded'); };
      if (img.complete && img.naturalWidth) loaded(); else img.addEventListener('load', loaded, { once: true });
    }
    var self = this;
    node.addEventListener('click', function () { self.openDetail(r, 0); });
    node.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.openDetail(r, 0); } });
    return node;
  };

  /* ---------- detail / lightbox ---------- */
  Widget.prototype.openDetail = function (r, idx) {
    var m = this.detail;
    var imgs = r.image_urls || [];
    var panel = m.querySelector('.bzr-detail');
    panel.classList.toggle('bzr-detail--noimg', !imgs.length);
    m.querySelector('[data-bzr-detail-media]').hidden = !imgs.length;
    m.querySelector('[data-bzr-detail-name]').textContent = r.display_name;
    m.querySelector('[data-bzr-detail-verified]').hidden = !r.verified;
    m.querySelector('[data-bzr-detail-stars]').innerHTML = stars(r.rating);
    m.querySelector('[data-bzr-detail-text]').textContent = r.body;
    m.querySelector('[data-bzr-detail-date]').textContent = fmtDate(r.created_at);
    var i = idx || 0;
    var img = m.querySelector('[data-bzr-detail-img]');
    var prev = m.querySelector('[data-bzr-detail-prev]'), next = m.querySelector('[data-bzr-detail-next]');
    function show() { img.src = imgs[i] || ''; prev.hidden = next.hidden = imgs.length < 2; }
    prev.onclick = function () { i = (i - 1 + imgs.length) % imgs.length; show(); };
    next.onclick = function () { i = (i + 1) % imgs.length; show(); };
    if (imgs.length) show();
    this.open(m);
  };

  Widget.prototype.open = function (m) {
    m.hidden = false; lockScroll(true);
    var self = this;
    this._esc = function (e) { if (e.key === 'Escape') self.close(m); };
    document.addEventListener('keydown', this._esc);
  };
  Widget.prototype.close = function (m) {
    m.hidden = true; lockScroll(false);
    if (this._esc) document.removeEventListener('keydown', this._esc);
  };

  /* ---------- funnel ---------- */
  Widget.prototype.openFunnel = function () {
    var f = this.funnel, t = this.texts;
    this.fState = { step: 1, rating: 0, files: [], text: '', first: '', last: '', email: '', busy: false };
    f.querySelector('[data-bzr-t="photo-title"]').textContent = t.photoTitle;
    f.querySelector('[data-bzr-t="photo-sub"]').textContent = t.photoSub;
    f.querySelector('[data-bzr-t="photo-offer"]').textContent = t.photoOffer;
    f.querySelector('[data-bzr-t="text-title"]').textContent = t.textTitle;
    f.querySelector('[data-bzr-t="thanks-code"]').textContent = t.thanksCode;
    f.querySelector('[data-bzr-text]').placeholder = t.textPlaceholder || '';
    f.querySelector('[data-bzr-text]').value = '';
    f.querySelector('[data-bzr-first]').value = '';
    f.querySelector('[data-bzr-last]').value = '';
    f.querySelector('[data-bzr-email]').value = '';
    f.querySelector('[data-bzr-previews]').innerHTML = '';
    f.querySelector('[data-bzr-error]').hidden = true;
    f.querySelectorAll('[data-bzr-rate] button').forEach(function (b) { b.classList.remove('is-on', 'is-pop'); });
    this.goStep(1);
    this.open(f);
  };

  Widget.prototype.goStep = function (n) {
    var f = this.funnel, st = this.fState;
    var prev = st.step;
    st.step = n;
    f.querySelectorAll('[data-bzr-step]').forEach(function (s) {
      var is = Number(s.dataset.bzrStep) === n;
      s.classList.remove('is-enter-fwd', 'is-enter-back');
      s.hidden = !is;
      if (is && prev && prev !== n && !REDUCED) {
        void s.offsetWidth;
        s.classList.add(n > prev ? 'is-enter-fwd' : 'is-enter-back');
      }
    });
    var nav = f.querySelector('[data-bzr-nav]');
    nav.hidden = n === 5;
    f.querySelectorAll('[data-bzr-progress] i').forEach(function (i, idx) { i.classList.toggle('is-on', idx < n); });
    var back = f.querySelector('[data-bzr-back]'), next = f.querySelector('[data-bzr-next]');
    back.disabled = n === 1;
    next.hidden = n === 1;
    next.classList.toggle('is-text', n === 2);
    next.textContent = n === 4 ? 'Weiter' : (n === 2 && !st.files.length ? 'Überspringen' : 'Weiter');
    this.validateStep();
    if (n === 3) setTimeout(function () { f.querySelector('[data-bzr-text]').focus(); }, 380);
    f.querySelector('.bzr-modal__panel').scrollTop = 0;
  };

  Widget.prototype.validateStep = function () {
    var f = this.funnel, st = this.fState, next = f.querySelector('[data-bzr-next]');
    var ok = true;
    if (st.step === 3) ok = f.querySelector('[data-bzr-text]').value.trim().length >= 3;
    if (st.step === 4) {
      var first = f.querySelector('[data-bzr-first]').value.trim();
      var email = f.querySelector('[data-bzr-email]').value.trim();
      ok = first.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    next.disabled = !ok || st.busy;
  };

  Widget.prototype.addFiles = function (list) {
    var f = this.funnel, st = this.fState, self = this;
    Array.prototype.slice.call(list).forEach(function (file) {
      if (st.files.length >= 3 || !/^image\//.test(file.type)) return;
      st.files.push({ file: file, url: URL.createObjectURL(file) });
    });
    var wrap = f.querySelector('[data-bzr-previews]');
    wrap.innerHTML = '';
    st.files.forEach(function (it, idx) {
      var fig = el('<figure><img src="' + it.url + '" alt=""><button type="button" aria-label="Entfernen">×</button></figure>');
      fig.querySelector('button').addEventListener('click', function () {
        URL.revokeObjectURL(it.url); st.files.splice(idx, 1); self.addFiles([]);
      });
      wrap.appendChild(fig);
    });
    f.querySelector('[data-bzr-next]').textContent = st.files.length ? 'Weiter' : 'Überspringen';
    f.querySelector('[data-bzr-file]').value = '';
  };

  Widget.prototype.upload = function (blob) {
    var self = this;
    var now = new Date();
    var path = 'uploads/' + now.getFullYear() + '/' + String(now.getMonth() + 1).padStart(2, '0') + '/' + uuid() + '.jpg';
    return fetch(this.url + '/storage/v1/object/review-images/' + path, {
      method: 'POST',
      headers: this.headers({ 'Content-Type': 'image/jpeg', 'x-upsert': 'false' }),
      body: blob
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('upload: ' + t); });
      return self.url + '/storage/v1/object/public/review-images/' + path;
    });
  };

  Widget.prototype.submit = function () {
    var f = this.funnel, st = this.fState, self = this;
    var err = f.querySelector('[data-bzr-error]');
    var next = f.querySelector('[data-bzr-next]');
    if (st.busy) return;
    st.first = f.querySelector('[data-bzr-first]').value.trim();
    st.last = f.querySelector('[data-bzr-last]').value.trim();
    st.email = f.querySelector('[data-bzr-email]').value.trim();
    st.text = f.querySelector('[data-bzr-text]').value.trim();
    var honeypot = f.querySelector('input[name="website"]').value;
    st.busy = true; next.classList.add('is-busy'); next.textContent = 'Wird gesendet…'; next.disabled = true; err.hidden = true;

    var chain = Promise.resolve([]);
    if (!honeypot) {
      chain = st.files.reduce(function (p, it) {
        return p.then(function (urls) {
          return resizeImage(it.file, 1600, 0.85).then(function (b) { return self.upload(b); }).then(function (u) { urls.push(u); return urls; });
        });
      }, Promise.resolve([]));
    }

    chain.then(function (urls) {
      if (honeypot) return [];
      return self.rest('/rest/v1/product_reviews', {
        method: 'POST',
        headers: { Prefer: 'return=minimal' },
        body: {
          product_id: self.productId, product_handle: self.productHandle,
          rating: st.rating, first_name: st.first, last_name: st.last || null,
          email: st.email, body: st.text, image_urls: urls
        }
      }).then(function () { return urls; });
    }).then(function (urls) {
      st.busy = false; next.classList.remove('is-busy');
      var live = st.rating >= 4;
      f.querySelector('[data-bzr-thanks-title]').textContent = (self.texts.thanksTitle || 'Danke!').replace('{name}', st.first);
      f.querySelector('[data-bzr-thanks-text]').textContent = live ? self.texts.thanksLive : self.texts.thanksPending;
      var codeBox = f.querySelector('[data-bzr-code]');
      var hasCode = !!(self.discountCode && urls && urls.length && !honeypot);
      codeBox.hidden = !hasCode;
      if (hasCode) f.querySelector('[data-bzr-code-value]').textContent = self.discountCode;
      self.goStep(5);
      confetti(f.querySelector('.bzr-modal__panel'));
      if (live && !honeypot) {
        var display = st.first + (st.last ? ' ' + st.last.charAt(0) + '.' : '');
        var r = { display_name: display, rating: st.rating, body: st.text, image_urls: urls || [], verified: false, created_at: new Date().toISOString() };
        self.ensureCols();
        self.items.unshift(r);
        if (self.cols[0]) self.cols[0].insertBefore(self.card(r), self.cols[0].firstChild);
        self.q('[data-bzr-empty]').hidden = true;
      }
    }).catch(function (e) {
      console.warn('[bzr] submit', e);
      st.busy = false; next.classList.remove('is-busy'); next.textContent = 'Weiter'; next.disabled = false;
      err.textContent = 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.';
      err.hidden = false;
    });
  };

  Widget.prototype.bindUI = function () {
    var self = this, root = this.root, f = this.funnel, m = this.detail;

    this.q('[data-bzr-more]').addEventListener('click', function () { self.loadMore(); });

    var countBtn = this.q('[data-bzr-count]'), bd = this.q('[data-bzr-breakdown]');
    countBtn.addEventListener('click', function () {
      var open = bd.hidden; bd.hidden = !open; countBtn.setAttribute('aria-expanded', String(open));
    });
    bd.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bd]'); if (!b) return;
      self.filterRating = b.dataset.bd === 'all' ? null : Number(b.dataset.bd);
      bd.hidden = true; countBtn.setAttribute('aria-expanded', 'false');
      self.reset();
    });

    var sortBtn = this.q('[data-bzr-sort-toggle]'), sortMenu = this.q('[data-bzr-sort]');
    sortMenu.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x.dataset.sort === self.sort); });
    sortBtn.addEventListener('click', function () {
      var open = sortMenu.hidden; sortMenu.hidden = !open; sortBtn.setAttribute('aria-expanded', String(open));
    });
    sortMenu.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sort]'); if (!b) return;
      sortMenu.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      self.sort = b.dataset.sort; sortMenu.hidden = true; sortBtn.setAttribute('aria-expanded', 'false');
      self.reset();
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { bd.hidden = true; sortMenu.hidden = true; }
      else {
        if (!e.target.closest('[data-bzr-count]') && !e.target.closest('[data-bzr-breakdown]')) bd.hidden = true;
        if (!e.target.closest('[data-bzr-sort-toggle]') && !e.target.closest('[data-bzr-sort]')) sortMenu.hidden = true;
      }
    });

    var write = this.q('[data-bzr-write]');
    if (write) write.addEventListener('click', function () { self.openFunnel(); });

    var resizeT;
    var relayout = function () { clearTimeout(resizeT); resizeT = setTimeout(function () { self.ensureCols(); }, 120); };
    window.addEventListener('resize', relayout);
    window.addEventListener('orientationchange', relayout);
    if (window.ResizeObserver) new ResizeObserver(relayout).observe(root);

    if (m && !m.dataset.bound) {
      m.dataset.bound = '1';
      m.querySelectorAll('[data-bzr-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(m); }); });
    }
    if (f && !f.dataset.bound) {
      f.dataset.bound = '1';
      f.querySelectorAll('[data-bzr-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(f); }); });
      var rateBtns = f.querySelectorAll('[data-bzr-rate] button');
      rateBtns.forEach(function (b) {
        b.innerHTML = STAR;
        function paint(n) { rateBtns.forEach(function (x) { x.classList.toggle('is-on', Number(x.dataset.rate) <= n); }); }
        b.addEventListener('mouseenter', function () { paint(Number(b.dataset.rate)); });
        b.addEventListener('mouseleave', function () { paint(self.fState ? self.fState.rating : 0); });
        b.addEventListener('click', function () {
          var n = Number(b.dataset.rate);
          self.fState.rating = n; paint(n);
          rateBtns.forEach(function (x, idx) {
            if (idx + 1 > n) return;
            setTimeout(function () { x.classList.remove('is-pop'); void x.offsetWidth; x.classList.add('is-pop'); }, idx * 45);
          });
          setTimeout(function () { self.goStep(2); }, 520);
        });
      });
      f.querySelector('[data-bzr-file]').addEventListener('change', function (e) { self.addFiles(e.target.files); });
      f.querySelector('[data-bzr-text]').addEventListener('input', function () { self.validateStep(); });
      ['[data-bzr-first]', '[data-bzr-last]', '[data-bzr-email]'].forEach(function (sel) {
        f.querySelector(sel).addEventListener('input', function () { self.validateStep(); });
      });
      f.querySelector('[data-bzr-back]').addEventListener('click', function () { if (self.fState.step > 1) self.goStep(self.fState.step - 1); });
      f.querySelector('[data-bzr-next]').addEventListener('click', function () {
        var s = self.fState.step;
        if (s === 2) self.goStep(3);
        else if (s === 3) self.goStep(4);
        else if (s === 4) self.submit();
      });
      f.querySelector('[data-bzr-form]').addEventListener('submit', function (e) { e.preventDefault(); });
      f.querySelector('[data-bzr-form]').addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); if (self.fState.step === 4 && !f.querySelector('[data-bzr-next]').disabled) self.submit(); }
      });
      f.querySelector('[data-bzr-copy]').addEventListener('click', function () {
        var code = f.querySelector('[data-bzr-code-value]').textContent;
        var btn = this;
        (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () { btn.textContent = 'Kopiert ✓'; setTimeout(function () { btn.textContent = 'Kopieren'; }, 1800); }).catch(function () {});
      });
    }
  };

  /* Static instance (from theme.liquid) steps back as soon as a movable template instance exists on the page. */
  function reconcileStatic() {
    var staticSection = document.getElementById(STATIC_ID);
    if (!staticSection) return;
    var others = Array.prototype.filter.call(document.querySelectorAll('[data-bzr]'), function (r) { return !staticSection.contains(r); });
    staticSection.style.display = others.length ? 'none' : '';
  }

  function boot() {
    reconcileStatic();
    document.querySelectorAll('[data-bzr]').forEach(function (root) {
      if (root.dataset.bzrReady) return;
      var sec = root.closest('.shopify-section');
      if (sec && sec.id === STATIC_ID && sec.style.display === 'none') return;
      root.dataset.bzrReady = '1';
      new Widget(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () { setTimeout(reconcileStatic, 50); });
})();

